import React from 'react';
import { Box } from "@mui/material";

// Importación de componentes individuales según tu estructura de archivos
import GestorIngresoTramite from './GestorIngresoTramite';
import GestorTurnoMedico from './GestorTurnoMedico';
import GestorEsperaDocumentacion from './GestorEsperaDocumentacion';
import GestorEnviadosMedica from './GestorEnviadosMedica';
import GestorPreparandoTelegrama from './GestorPreparandoTelegrama';
import GestorTelegramaEnviado from './GestorTelegramaEnviado';
import GestorCitacionART from './GestorCitacionART';
import GestorRespuestaART from './GestorRespuestaART';
import GestorEsperaAnexo from './GestorEsperaAnexo';
import GestorComisionMedica from './GestorComisionMedica';
import GestorResolucionSRT from './GestorResolucionSRT';
import GestorJudicializado from './GestorJudicializado';
import GestorFinalizado from './GestorFinalizado';

function GestorCambioEstadoART({ tramite, onEstadoCambiado }) {
    if (!tramite) return null;

    const renderGestor = () => {
        // Los strings deben ser EXACTAMENTE iguales a los del INSERT de SQL (V53)
        // Se usa toLowerCase() para manejar variaciones de case
        const estadoNormalizado = tramite.nombreEstadoActual?.toLowerCase().trim() || '';

        switch (estadoNormalizado) {
            case "ingreso del trámite":
                return <GestorIngresoTramite tramite={tramite} onAvanzar={onEstadoCambiado} />;

            case "turno médico asignado":
                return <GestorTurnoMedico tramite={tramite} onAvanzar={onEstadoCambiado} />;

            case "espera de documentación":
                return <GestorEsperaDocumentacion tramite={tramite} onAvanzar={onEstadoCambiado} />;

            case "enviados a la médica":
                return <GestorEnviadosMedica tramite={tramite} onAvanzar={onEstadoCambiado} />;

            case "preparando telegrama":
                return <GestorPreparandoTelegrama tramite={tramite} onAvanzar={onEstadoCambiado} />;

            case "telegrama enviado":
                return <GestorTelegramaEnviado tramite={tramite} onAvanzar={onEstadoCambiado} />;

            case "citación art":
                return <GestorCitacionART tramite={tramite} onAvanzar={onEstadoCambiado} />;

            case "respuesta art":
                return <GestorRespuestaART tramite={tramite} onAvanzar={onEstadoCambiado} />;

            case "pendiente de anexo":
                return <GestorEsperaAnexo tramite={tramite} onAvanzar={onEstadoCambiado} />;

            case "iniciado en comisión médica":
                return <GestorComisionMedica tramite={tramite} onAvanzar={onEstadoCambiado} />;

            case "resolución srt":
                return <GestorResolucionSRT tramite={tramite} onAvanzar={onEstadoCambiado} />;

            case "judicializado":
                return <GestorJudicializado tramite={tramite} onAvanzar={onEstadoCambiado} />;

            case "finalizado":
                return <GestorFinalizado tramite={tramite} />;

            default:
                return (
                    <Box className="alert alert-light border rounded-4 p-3 text-muted">
                        <small>Sin acciones configuradas para el estado actual: {tramite.nombreEstadoActual}</small>
                    </Box>
                );
        }
    };

    return (
        <Box className="animate__animated animate__fadeIn">
            {renderGestor()}
        </Box>
    );
}

export default GestorCambioEstadoART;